import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core'
import {QuestionDirective} from 'app/shared/directives/question.directive'
import {Question} from 'app/models/questions/Question'
import {IQuestionComponent} from 'app/interfaces/IQuestionComponent'
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog'
import {ChatComponent} from 'app/modules/survey/survey-viewer/chat/chat.component'
import {IComment} from 'app/interfaces/IComment'
import {ChatService} from 'app/modules/survey/survey-viewer/services/chat.service'
import {SurveyViewerService} from 'app/modules/survey/survey-viewer/services/survey-viewer.service'
import {ViewerTypeEnum} from 'app/enums/ViewerTypeEnum'
import {AuthService} from "../../../../core/auth/auth.service";
import {AppModeService} from "@store/services/app-mode.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {ValidateCommentsAIService} from '@store/validateCommentsAI.service';
import {AsyncPipe, NgIf} from "@angular/common";
import {MatLegacyButtonModule as MatButtonModule} from "@angular/material/legacy-button";
import {MatIconModule} from "@angular/material/icon";
import {MatLegacyTooltipModule as MatTooltipModule} from "@angular/material/legacy-tooltip";
import {PipesModule} from "../../../../pipes/pipes.module";
import {MatBadgeModule} from "@angular/material/badge";
import {DirectivesModule} from "@store/directives/directives.module";
import {TranslocoModule} from "@ngneat/transloco";

@UntilDestroy()
@Component({
  selector: 'app-survey-question',
  templateUrl: './survey-question.component.html',
  styleUrls: ['./survey-question.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    PipesModule,
    MatBadgeModule,
    DirectivesModule,
    TranslocoModule,
    NgIf
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurveyQuestionComponent implements OnInit, OnChanges {

  @ViewChild(QuestionDirective, {static: true}) appQuestion!: QuestionDirective

  _question: Question
  @Input() set question(value: Question) {
    this._question = value
    if (this._question.createUser) {
      this.surveyViewerService.changeCreateUserOnSubmit(true)
    }
  }

  @Input() isSmallScreen: boolean
  @Input() activeLang: string
  @Input() displayChat: boolean
  @Input() surveyId: string

  questionType = ViewerTypeEnum

  private componentRef: ComponentRef<IQuestionComponent>

  constructor(
    public dialog: MatDialog,
    public chatService: ChatService,
    public surveyViewerService: SurveyViewerService,
    public authService: AuthService,
    public validateAIService: ValidateCommentsAIService,
    private renderer: Renderer2,
    private el: ElementRef,
    private appModeService: AppModeService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.buildQuestionComponent()

    if (this._question.viewerType === ViewerTypeEnum.HONEYPOT) {
      this.renderer.addClass(this.el.nativeElement, 'question-hp')
    }

    this.appModeService.isDisplayDebug$
      .pipe(untilDestroyed(this))
      .subscribe((isDebug) => {
        if (isDebug) {
          this.renderer.addClass(this.el.nativeElement, 'quickFix')
        } else {
          this.renderer.removeClass(this.el.nativeElement, 'quickFix')
        }
      });

  }

  ngOnChanges(): void {

    if (this.componentRef) {
      this.componentRef.destroy()
      this.buildQuestionComponent()
    }

    setTimeout(() => {
      this.cdr.markForCheck()
      this.cdr.detectChanges()
    }, 500)

  }

  private buildQuestionComponent() {
    this.componentRef = this.appQuestion.viewContainerRef.createComponent(this._question.getDisplayComponent().component)
    this.componentRef.instance.question = this._question
    this.componentRef.instance.isSmallScreen = this.isSmallScreen
    this.componentRef.instance.activeLang = this.activeLang
  }

  openChat() {
    return this.dialog.open(ChatComponent, {
      data: {
        question: this._question,
        surveyId: this.surveyId,
        activeLang: this.activeLang
      },
      width: '850px',
      maxHeight: '750px',
      autoFocus: false,
    })
  }

  getCommentCountByQuestion(comments: IComment[]): number {
    const questionComments = comments.filter(c => c.referenceKey === this._question.key)
    return questionComments.length
  }

  get createUser() {
    return !this._question.createUser || (this._question.createUser && (!this.authService.isLogged() || this.surveyViewerService.isPreview()))
  }
}
